import React from 'react'
import HeroSection from './hero-section'
import CostumersTalking from './costumers-talking'
import FeaturesSection from './features-section'
import GetYourAppSection from './get-your-app-section'
import './index.css'

const Howjsay = () => (
  <>
    <HeroSection />
    <CostumersTalking />
    <FeaturesSection />
    <GetYourAppSection />
  </>
)

export default Howjsay;